export function getLatLng(location: string) {
  return location?.split('POINT')[1]?.replace(/[()]/g, '')?.trim()?.split(' ');
}
